import { render, staticRenderFns } from "./ActivitiesList.vue?vue&type=template&id=5c7b3501&scoped=true"
import script from "./ActivitiesList.vue?vue&type=script&lang=js"
export * from "./ActivitiesList.vue?vue&type=script&lang=js"
import style0 from "./ActivitiesList.vue?vue&type=style&index=0&id=5c7b3501&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7b3501",
  null
  
)

export default component.exports